import PatientReferralForm from '@/website/routes/patient-referral/components/PatientReferralForm.tsx';
import PageHeader from '@/website/components/PageHeader.tsx';
import FormResultMessage from '@/website/routes/patient-referral/components/FormResultMessage.tsx';

const PatientReferralPage = () => {
  return (
    <>
      <PageHeader title="Refer a Patient" imageSrc="/images/sent-message.svg" />
      <FormResultMessage />
      <PatientReferralForm />
    </>
  );
};

export default PatientReferralPage;
